/*!

=========================================================
* Black Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// reactstrap components
import {
    Button,
    Modal,
    ModalBody,
    Card,
    CardHeader,
    CardBody,
    CardText,
    Collapse,
    FormGroup,
    Label,
    Input
} from "reactstrap";
//redux components
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// actions
import { 
  fetchAddUser,
  fetchGetValidationUserId
} from "../../actions/user_actions";

class UserEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        userView: {},
        modelToDelete: [],
        editModel: false,
        openedCollapses: [],
        openedCollapsesVersions: [],
    };
  }

  componentDidMount() {
    const { showModelEdit } = this.props;
  }

  componentDidUpdate(prevProps, prevState) {
    const { user } = this.props;
  }

  collapsesToggle = (e, collapse) => {
    e.preventDefault();
    let openedCollapses = this.state.openedCollapses;
    if (openedCollapses.includes(collapse)) {
      this.setState({
        openedCollapses: openedCollapses.filter(item => item !== collapse)
      });
    } else {
      openedCollapses.push(collapse);
      this.setState({
        openedCollapses: openedCollapses
      });
    }
  };

  collapsesToggleVersions = (e, collapse) => {
    e.preventDefault();
    let openedCollapses = this.state.openedCollapsesVersions;
    if (openedCollapses.includes(collapse)) {
      this.setState({
        openedCollapsesVersions: openedCollapses.filter(item => item !== collapse)
      });
    } else {
      openedCollapses.push(collapse);
      this.setState({
        openedCollapsesVersions: openedCollapses
      });
    }
  };

  render() {
    const {
        user,
        modalEditUserData, 
        toggleModalEditUserData, 
        warningWithConfirmMessageDeleteModel,
        handleEditModelModal,
        handleAddModelModal,
        toggleModalEditModel,
        handleModalVersionModel,
        warningWithConfirmMessageDeleteVersion,
        modelToDelete,
        userView
    } = this.props;
    // console.log(user);
    return (
      <>
        <Modal
            isOpen={modalEditUserData}
            toggle={toggleModalEditUserData}
            size="lg"
        >
            <div className="modal-header justify-content-center">
                <button
                    aria-hidden={true}
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={toggleModalEditUserData}
                >
                    <i className="tim-icons icon-simple-remove" />
                </button>
                <h4 className="title title-up">User Edit</h4>
            </div>
            <ModalBody className="text-left">
                <p>
                    <span style={{fontWeight: 700, marginRight: "5px"}}>Email: </span> {userView && userView.email ? userView.email : ""}
                </p>
                <p>
                    <span style={{fontWeight: 700, marginRight: "5px"}}>Organization: </span> {userView && userView.organization ? userView.organization : ""}
                </p>
                <p>
                    <span style={{fontWeight: 700, marginRight: "5px"}}>User Id: </span> {userView && userView.user_id ? userView.user_id : ""}
                </p>
                <p>
                    <span style={{fontWeight: 700, marginRight: "5px"}}>Models: </span>
                    <Button 
                        className="btn-round btn-icon btn-round-right" 
                        color="danger" 
                        onClick={warningWithConfirmMessageDeleteModel}
                        disabled={modelToDelete.length > 1 || modelToDelete.length === 0 ? true : false}
                    >
                        <i className="tim-icons icon-simple-remove"/>
                    </Button>
                    <Button 
                        className="btn-round btn-icon btn-round-right" 
                        color="primary" 
                        onClick={handleEditModelModal} 
                        disabled={modelToDelete.length > 1 || modelToDelete.length === 0 ? true : false}
                    >
                        <i className="tim-icons icon-pencil"/>
                    </Button>
                    <Button 
                        className="btn-round btn-icon btn-round-right" 
                        color="info" 
                        onClick={handleAddModelModal}
                    >
                        <i className="tim-icons icon-simple-add"/>
                    </Button>
                </p>
                <div
                    aria-multiselectable={true}
                    className="card-collapse"
                    id="accordion"
                    role="tablist"
                    style={{border: "1px solid #ccc", padding: "0.01em 10px", borderRadius: "5px", marginTop: "13px"}}
                >
                {user && user.user_models && user.user_models.user_models && user.user_models.user_models.map((val, index) => 
                    <Card className="card-plain" key={index} style={{borderTop: index !== 0 ? "1px solid #ccc" : null, borderRadius: "0px"}}>
                        <CardHeader role="tab">
                            <FormGroup check className="pull-left" style={{marginTop: "0px"}}>
                            <Label check style={{color: "#fff"}}>
                                <Input name="optionCheckboxes" type="checkbox" onClick={()=>toggleModalEditModel(val)}/>
                                <span className="form-check-sign" />
                                .
                            </Label>
                            </FormGroup>
                            <a
                                aria-expanded={this.state.openedCollapses.includes(
                                    index
                                )}
                                href="#pablo"
                                data-parent="#accordion"
                                data-toggle="collapse"
                                onClick={e => this.collapsesToggle(e, index)}
                                style={{color: "#000"}}
                            >
                                {val.model_name}{" "}
                                <i className="tim-icons icon-minimal-down" style={{marginTop: "6px"}}/>
                            </a>
                        </CardHeader>
                        {/* {console.log(this.state.openedCollapses, index)} */}
                        <Collapse
                            role="tabpanel"
                            isOpen={this.state.openedCollapses.includes(
                                index
                            )}
                        >
                            <CardBody style={{color: "#000", border: "1px solid #ccc", padding: "10px", borderRadius: "5px", marginBottom: "5px"}}>
                            <p>
                                <span style={{fontWeight: 700, marginRight: "5px"}}>Description: </span> {val.description}
                            </p>
                            <p>
                                <span style={{fontWeight: 700, marginRight: "5px"}}>Routing Table: </span>
                            </p>
                            {val.routing_table && Object.keys(val.routing_table).length !== 0 ? Object.keys(val.routing_table).map((value_aux, j) => {
                                return (
                                    <div key={j} style={{marginLeft: "5px"}}>
                                        <span style={{fontWeight: 600, marginRight: "5px"}}>{value_aux + ": "}</span>{val.routing_table[value_aux]}
                                    </div>
                                    );
                                }) : 
                                <CardText tag="h6" style={{color: "#000", display: "flex", justifyContent: "center", alignItems: "center"}}>This model doesn't have any route</CardText>
                            }
                            <p>
                                <span style={{fontWeight: 700, marginRight: "5px"}}>Versions: </span>
                                <Button 
                                    className="like btn-neutral" 
                                    color="info" 
                                    style={{float: 'right', paddingTop: "2px", paddingRight: "5px", maxWidth: "134px", maxHeight: "20px"}} 
                                    onClick={()=>handleModalVersionModel(val)}
                                >
                                    Add Version
                                </Button>
                            </p>
                            {val && val.versioning && val.versioning.length !== 0 ?
                                <div
                                    aria-multiselectable={true}
                                    className="card-collapse"
                                    id="accordion"
                                    role="tablist"
                                    style={{border: "1px solid #ccc", padding: "0.01em 10px", borderRadius: "5px", backgroundColor: "#F0F0F0"}}
                                >
                                {val.versioning.map((value, i) => {
                                    return (
                                    <Card className="card-plain" key={i} style={{borderTop: i !== 0 ? "1px solid #ccc" : null, borderRadius: "0px"}}>
                                        <CardHeader role="tab">
                                            <FormGroup check className="pull-left" style={{marginTop: "0px"}}>
                                                <Button 
                                                    className="btn-round btn-icon btn-delete-icon" 
                                                    color="danger" 
                                                    style={{marginRight: "8px", display: "flex", justifyContent: "center", alignItems: "center"}} 
                                                    onClick={()=>warningWithConfirmMessageDeleteVersion(val, value)}
                                                >
                                                    x
                                                </Button>
                                            </FormGroup>
                                            <a
                                                aria-expanded={this.state.openedCollapsesVersions.includes(
                                                    i
                                                )}
                                                href="#pablo"
                                                data-parent="#accordion"
                                                data-toggle="collapse"
                                                onClick={e => this.collapsesToggleVersions(e, i)}
                                                style={{color: "#000"}}
                                            >
                                                {value.version_name}{" "}
                                                <i className="tim-icons icon-minimal-down" style={{marginTop: "6px"}}/>
                                            </a>
                                        </CardHeader>
                                        <Collapse
                                            role="tabpanel"
                                            isOpen={this.state.openedCollapsesVersions.includes(
                                                i
                                            )}
                                        >
                                            <CardBody style={{color: "#000"}}>
                                                <p>
                                                    <span style={{fontWeight: 700, marginRight: "5px"}}>Version Date: </span>{value.version_date}
                                                </p>
                                                <p>
                                                    <span style={{fontWeight: 700, marginRight: "5px"}}>Version Performance Metrics: </span>
                                                </p>
                                                {Object.keys(value.version_performance_metrics).length !== 0 ? Object.keys(value.version_performance_metrics).map((aux, j) => {
                                                    return (
                                                        <div key={j}>
                                                            <span style={{fontWeight: 600, marginRight: "5px"}}>{aux + ": "}</span>{value.version_performance_metrics[aux]}
                                                        </div>
                                                        );
                                                    }) : 
                                                    <CardText tag="h6" style={{color: "#000", display: "flex", justifyContent: "center", alignItems: "center"}}>This model doesn't have any metrics</CardText>
                                                }
                                            </CardBody>
                                        </Collapse>
                                    </Card>
                                    )}
                                )}
                                </div> :
                                <h6 style={{textAlign: "center"}}>
                                    <span style={{color: "#000"}}>
                                        This model doesn't have versions
                                    </span>
                                </h6>
                            }
                            </CardBody>
                        </Collapse>
                    </Card>
                )}
                {user && user.user_models && user.user_models.user_models && user.user_models.user_models.length === 0 &&
                    <h6 style={{textAlign: "center"}}>
                        <span style={{color: "#000"}}>
                            You don't have any models
                        </span>
                    </h6>
                }
                </div>
            </ModalBody>
            <div className="modal-footer">
                <Button
                    color="info"
                    data-dismiss="modal"
                    type="button"
                    onClick={toggleModalEditUserData}
                >
                    Save Model
                </Button>
            </div>
        </Modal>
      </>
    );
  }
}

function mapStateToProps({model, auth, user}){
  return{
      model,
      auth,
      user
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators(
      { fetchAddUser, fetchGetValidationUserId }, dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(UserEditModal);